import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faMedium } from '@fortawesome/free-brands-svg-icons/faMedium';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/yonatanbebchuk',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.instagram.com/yonatanbebchuk/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/yonatan-bebchuk-271369274/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://twitter.com/yonatanbebchuk',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:yonatanbebchuk@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
  {
    link: 'https://medium.com/@yonatanbebchuk',
    label: 'Medium',
    icon: faMedium,
  },
];

export default data;
